import {HTMLProps, ReactNode} from 'react';

interface IProps extends HTMLProps<HTMLDivElement> {
  isRound?: boolean;
  showBoxShadow?: boolean;
  leftElement?: ReactNode;
  leftElementClassName?: string;
  rightElement?: ReactNode;
  rightElementClassName?: string;
}

export default function EventRowItemV4({
  isRound,
  showBoxShadow,
  style,
  className,
  leftElement,
  leftElementClassName,
  rightElement,
  rightElementClassName,
  ...rest
}: IProps) {
  return (
    <div
      className={cn('flex items-center justify-between', className, {
        'rounded-12 px-18 min-h-[80px]': isRound,
      })}
      style={
        showBoxShadow
          ? {boxShadow: '0px 10px 10px rgba(0, 0, 0, 0.05)', ...style}
          : style
      }
      {...rest}
    >
      <div
        className={cn(ASIDE_ELEMENT_CN, leftElementClassName)}
        data-testid="left-element"
      >
        {leftElement}
      </div>
      <div
        className={cn(ASIDE_ELEMENT_CN, rightElementClassName)}
        data-testid="right-element"
      >
        {rightElement}
      </div>
    </div>
  );
}

const ASIDE_ELEMENT_CN = 'flex flex-col overflow-hidden';
